import { Dialog, DialogContent, Grid, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import EDButton from '../../../../../../atoms/EDButton/EDButton'

const ConfirmDeleteDialog = ({
  isOpen,
  onClose,
  onConfirm,
  itemToBeDeletedName,
  itemToBeDeletedDescription,
  item,
  children
}) => {
  const { t } = useTranslation()

  return (
    <Dialog fullWidth maxWidth='sm' open={isOpen} onClose={onClose}>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant='h2' fontSize={18} fontWeight={600}>
              ⚠️{' '}
              {t('confirm_delete_title', {
                title: itemToBeDeletedName
              })}{' '}
            </Typography>
          </Grid>

          {itemToBeDeletedDescription && (
            <Grid item xs={12}>
              <Typography fontSize={16}>
                {t(itemToBeDeletedDescription)}
              </Typography>
            </Grid>
          )}

          {children && (
            <Grid item xs={12}>
              {children}
            </Grid>
          )}

          <Grid item xs={12}>
            <Stack direction='row' spacing={2} justifyContent='flex-end'>
              <EDButton variant='text' onClick={onClose}>
                {t('No')}
              </EDButton>
              <EDButton
                disableElevation
                variant='contained'
                color='error'
                onClick={onConfirm}
              >
                {t('Yes')}
              </EDButton>
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
